import React from 'react';
import PropTypes from 'prop-types';
import { H6 } from 'components/Typography';
import { ExtraInstructions } from './styled';
import { CLAIM_TYPES } from '../../../../consts';

const Instructions = ({ claimType }) => {
  if (claimType === CLAIM_TYPES.TRAVEL) {
    return (
      <>
        <b>Please describe what happened, and what you would like to claim</b>
        <ExtraInstructions>
          If this was an accident, please provide a brief summary of the accident details.
        </ExtraInstructions>
      </>
    );
  }
  return <H6>Tell us what happened</H6>;
};

Instructions.propTypes = {
  claimType: PropTypes.string
};

export default Instructions;
